import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const ContactBoxes = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="flex flex-col md:flex-row justify-center gap-6">
        {/* Visit Our Office Details */}
        <div className="flex-1 bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 transform hover:-translate-y-2">
          <div className="flex items-center mb-4">
            <FaMapMarkerAlt className="text-orange-500 text-2xl mr-3" />
            <h3 className="text-xl font-semibold text-gray-800">Visit Our Office</h3>
          </div>
          <p className="text-gray-600">24, Iyalla Street, Ikaja
Lagos, Nigeria</p>
          <p className="text-gray-600">Monday - Friday: 9 AM - 5 PM</p>
        </div>

        {/* Contact Us */}
        <div className="flex-1 bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 transform hover:-translate-y-2">
          <div className="flex items-center mb-4">
            <FaPhoneAlt className="text-orange-500 text-2xl mr-3" />
            <h3 className="text-xl font-semibold text-gray-800">Contact Us</h3>
          </div>
          <p className="text-gray-600">+234 905 555 6666</p>
          <p className="text-gray-600">Available 24/7 for support</p>
        </div>

        {/* Email Us */}
        <div className="flex-1 bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 transform hover:-translate-y-2">
          <div className="flex items-center mb-4">
            <FaEnvelope className="text-orange-500 text-2xl mr-3" />
            <h3 className="text-xl font-semibold text-gray-800">Email Us</h3>
          </div>
          <p className="text-gray-600">essentialng@gmail.com</p>
          <p className="text-gray-600">Response within 24 hours</p>
        </div>
      </div>
    </div>
  );
};

export default ContactBoxes;